<template>
  <v-flex :md4="md==4">
    <b><fs1-span>{{label||'Especialidad'}}</fs1-span></b>
    <v-select
      :placeholder="value ? undefined : ' seleccionar'"
      v-model="model"
      :items="items"
      item-text="name"
      item-value="id"
      :disabled="disabled"
      :class="!value && 'textEmpty'"/>
  </v-flex>
</template>
<script>
export default {
  props: ['label','value','md','disabled'],
  data() {
    return { model:null }
  },
  computed: {
    items(){ return this.$store.getters.specialities },
  },
  watch: {
    'value'(v){ this.model=v },
    'model'(v){ this.$emit('update:value', v) }
  },
  created(){ this.model=[undefined].includes(this.value)?null:this.value },
};
</script>
